import React, { Component } from 'react'
import { Bar } from 'react-chartjs-2'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import { getChartsRatio } from 'helpers/slaMonitor'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { mathRound } from 'helpers/math'
import {
  resetVisibilityData,
  setListForecastData,
} from 'reducers/environmentMonitor/reducer'
import { SKY_BLUE } from 'constants/colors'
import messages from '../translate'

class SensorForecastBar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      datasetIndex: this.props.datasetIndex,
    }
  }

  componentWillUnmount() {
    this.props.resetVisibilityData()
  }

  componentDidUpdate(prevProps) {
    if (this.props.chartData !== prevProps.chartData) {
      this.props.setListForecastData({
        time: moment(),
        value: mathRound(this.props.chartData.get('avg')),
      })
    }
  }

  chartData = () => {
    const {
      intl: { formatMessage },
      chartData,
    } = this.props
    const data = chartData.toJS()

    return {
      labels: [
        Math.round(data.min),
        Math.round(data.avg),
        Math.round(data.max),
      ],
      datasets: [
        {
          label: formatMessage(messages.transparency),
          type: 'bubble',
          tooltip: false,
          pointRadius: 0,
          pointHitRadius: 0,
          pointBorderWidth: 0,
          pointHoverRadius: 0,
          backgroundColor: '#347975',
          order: 1,
          datalabels: {
            display: false,
          },
          data: [
            null,
            { x: data.avg, y: 0, r: data.avg !== null ? 15 : 0 },
            null,
          ],
        },
        {
          label: formatMessage(messages.confidenceInterval),
          type: 'bar',
          fill: false,
          tooltip: true,
          barPercentage: 1.5,
          backgroundColor: SKY_BLUE,
          data: [null, mathRound(data.avg), null],
          order: 2,
        },
      ],
    }
  }

  chartOptions = () => {
    const {
      intl: { formatMessage },
      chartData,
    } = this.props
    const pointRange = [
      mathRound(chartData.get('min')),
      mathRound(chartData.get('max')),
    ]

    return {
      aspectRatio: getChartsRatio(),
      responsive: true,
      scales: {
        xAxes: [
          {
            ticks: {
              fontColor: 'black',
              fontSize: 14,
              padding: 5,
              callback(value, index) {
                if (index !== 1) {
                  return value
                }
              },
            },
            scaleLabel: {
              display: true,
              labelString: `${formatMessage(messages.meters)}`,
            },
            gridLines: {
              display: true,
              offsetGridLines: false,
              lineWidth: 2,
              drawOnChartArea: false,
              color: 'black',
            },
          },
        ],
        yAxes: [
          {
            display: false,
          },
        ],
      },
      legend: {
        onClick: e => e.stopPropagation(),
      },
      tooltips: {
        mode: 'x',
        intersect: false,
        backgroundColor: '#03254a',
        animationDuration: 300,
        titleFontSize: 13,
        bodyFontSize: 10,
        caretSize: 10,
        yAlign: 'top',
        xAlign: 'center',
        filter: tooltipItem => tooltipItem.index === 1,
        callbacks: {
          title: () => formatMessage(messages.today),
          label: (tooltipItem, data) => {
            const dataset = data.datasets

            if (tooltipItem.datasetIndex !== 0) {
              return dataset.map(item => {
                if (item.type !== 'bubble') {
                  return `${item.label}: [${pointRange}]`
                }

                return `${item.label}: ${mathRound(item.data[1].x)}`
              })
            }

            return null
          },
        },
      },
      plugins: {
        datalabels: {
          color: 'black',
          align: () => 'center',
          anchor: 'center',
          labels: {
            value: {
              font: {
                weight: 'bold',
                size: ifWindowWidthLessThan(992) ? 20 : 30,
              },
            },
          },
        },
      },
    }
  }

  render() {
    return (
      <Bar
        width={null}
        height={null}
        data={this.chartData()}
        options={this.chartOptions()}
        getElementAtEvent={this.onChartClick}
      />
    )
  }
}

export default connect(null, {
  resetVisibilityData,
  setListForecastData,
})(injectIntl(SensorForecastBar))
